<template>
  <div class="wx-template-manage-page">
    <a-card :bordered="false" class="search-card">
      <a-form layout="inline">
        <a-form-item label="模板名称">
          <a-input v-model="query.title" placeholder="请输入" allow-clear />
        </a-form-item>
        <a-form-item label="租户名称">
          <a-input v-model="query.tenantName" placeholder="请输入" allow-clear />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="handleSearch">查询</a-button>
          <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
          <a-button style="margin-left: 8px" type="danger" :disabled="selectedRowKeys.length === 0" @click="handleBatchDelete">删除</a-button>
        </a-form-item>
        <a-button type="primary" icon="sync" class="sync-btn" :loading="syncLoading" @click="handleSyncTemplate">同步微信消息模板</a-button>
      </a-form>
    </a-card>

    <a-card :bordered="false">
      <a-table
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        :loading="loading"
        :row-selection="{ selectedRowKeys, onChange: onSelectChange }"
        :rowKey="(record, index) => index"
        @change="handleTableChange"
      >
        <template slot="action" slot-scope="text, record">
          <a @click="handleViewDetail(record)">详情</a>
        </template>
      </a-table>
    </a-card>

    <a-modal
      title="模板详情"
      :visible="detailVisible"
      :footer="null"
      @cancel="detailVisible = false"
      width="760px"
    >
      <a-descriptions bordered :column="1" size="small">
        <a-descriptions-item label="模板名称">{{ detailRecord.title || '-' }}</a-descriptions-item>
        <a-descriptions-item label="所属租户">{{ detailRecord.tenantName || '-' }}</a-descriptions-item>
        <a-descriptions-item label="创建时间">{{ detailRecord.createTime || '-' }}</a-descriptions-item>
        <a-descriptions-item label="模板内容">
          <div class="template-content-box" v-html="formatTemplateContent(detailRecord.content)"></div>
        </a-descriptions-item>
      </a-descriptions>
    </a-modal>
  </div>
</template>

<script>
import { selectWxTemplateByTenantId, obtainWxTemplate } from '@/api/serviceConfig'

export default {
  name: 'WxTemplateManagePage',
  data() {
    return {
      query: {
        title: '',
        tenantName: ''
      },
      loading: false,
      syncLoading: false,
      list: [],
      selectedRowKeys: [],
      columns: [
        { title: '模板名称', dataIndex: 'title', key: 'title', width: 150 },
        { title: '所属租户', dataIndex: 'tenantName', key: 'tenantName', width: 150 },
        { title: '模板内容', dataIndex: 'content', key: 'content', ellipsis: true },
        { title: '创建时间', dataIndex: 'createTime', key: 'createTime', width: 180 },
        { title: '操作', key: 'action', width: 100, scopedSlots: { customRender: 'action' } }
      ],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => `共 ${total} 条记录`
      },
      detailVisible: false,
      detailRecord: {}
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    loadList() {
      this.loading = true
      const params = {
        ispage: 0,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        title: this.query.title || undefined,
        tenantName: this.query.tenantName || undefined
      }
      selectWxTemplateByTenantId(params).then(res => {
        if (res.code === 0) {
          this.list = res.rows || res.data?.rows || res.data || []
          this.pagination.total = Number(res.total || res.data?.total || 0)
        } else {
          this.$message.error(res.message || '获取模板列表失败')
        }
      }).catch(() => {
        this.$message.error('获取模板列表失败')
      }).finally(() => {
        this.loading = false
      })
    },
    handleSearch() {
      this.pagination.current = 1
      this.loadList()
    },
    handleReset() {
      this.query = {
        title: '',
        tenantName: ''
      }
      this.pagination.current = 1
      this.loadList()
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadList()
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    handleBatchDelete() {
      if (!this.selectedRowKeys.length) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.$message.warning('当前后端未提供模板删除接口，请补充后我再接入')
    },
    handleSyncTemplate() {
      this.syncLoading = true
      obtainWxTemplate().then(res => {
        if (res.code === 0) {
          this.$message.success('同步成功')
          this.loadList()
        } else {
          this.$message.error(res.message || '同步失败')
        }
      }).catch(() => {
        this.$message.error('同步失败')
      }).finally(() => {
        this.syncLoading = false
      })
    },
    handleViewDetail(record) {
      this.detailRecord = { ...record }
      this.detailVisible = true
    },
    // 格式化模板内容，高亮变量
    formatTemplateContent (content) {
      if (!content) return '-'
      // 先转义HTML特殊字符，防止XSS
      let html = content
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
      // 将变量标记为高亮（使用 HTML 实体避免 Vue 解析）
      html = html
        .replace(/\{\{keyword1\.DATA\}\}/g, '<span class="highlight-var">&#123;&#123;keyword1.DATA&#125;&#125;</span>')
        .replace(/\{\{keyword2\.DATA\}\}/g, '<span class="highlight-var">&#123;&#123;keyword2.DATA&#125;&#125;</span>')
        .replace(/\{\{keyword3\.DATA\}\}/g, '<span class="highlight-var">&#123;&#123;keyword3.DATA&#125;&#125;</span>')
        .replace(/\n/g, '<br>')
      return html
    }
  }
}
</script>

<style lang="less" scoped>
.wx-template-manage-page {
  padding: 20px;
}

.search-card {
  margin-bottom: 16px;
}

.sync-btn {
  float: right;
}

.template-content-box {
  border-radius: 4px;
  padding: 12px 16px;
  line-height: 1.8;
  font-size: 14px;
  color: #262626;
  white-space: pre-wrap;
  word-break: break-all;
}

.highlight-var {
  background-color: #fff2f0;
  border: 1px solid #ffccc7;
  color: #cf1322;
  padding: 2px 6px;
  border-radius: 3px;
  font-family: 'Consolas', 'Monaco', monospace;
  font-size: 13px;
  margin: 0 2px;
}
</style>
